export const global = {
  'background-system': '#F4F5FA'
};
